export interface Toaster {
  id: string
  message: string
  type: 'success' | 'error' | 'info' | 'warning'
}

export const ToasterType = {
  SUCCESS: 'success',
  ERROR: 'error',
  INFO: 'info',
  WARNING: 'warning',
} as const
export type ToasterTypeValues = (typeof ToasterType)[keyof typeof ToasterType]

export interface ToasterState {
  toasters: Toaster[]
}
